import { useMemo } from 'react';

import { deleteAttendEvent, deleteAttendUser } from '@src/api/attend';
import { closeModal } from '@src/reduce/modals';
import { trigger } from '@src/utils/globalEvents';
import { Button } from 'antd';
import { useDispatch } from 'react-redux';

import * as S from './styled';
import type * as T from './type';

function ConfirmAlertModal({
  text,
  isConfirm,
  groupEventId,
  groupEventMemberIds,
}: T.ComfirmAlertProps) {
  const dispatch = useDispatch();

  const onClickEvent = async () => {
    if (groupEventId && groupEventMemberIds) {
      await deleteAttendUser({ path: { groupEventId }, body: { groupEventMemberIds } });
      trigger('SUCCESS_UPDATE_ATTEND_USER');
    } else if (groupEventId) {
      await deleteAttendEvent({ path: { groupEventId } });
      trigger('SUCCESS_UPDATE_ATTEND_EVENT');
    }

    close();
  };

  const close = () => {
    dispatch(closeModal('confirmAlertModal'));
  };

  const footBtns = useMemo(() => {
    return [
      isConfirm ? <Button onClick={close}>취소</Button> : null,
      <Button onClick={onClickEvent} className={'okBtn'}>
        확인
      </Button>,
    ];
  }, []);

  return (
    <S.AlertBox open={true} footer={footBtns} width='440px' onCancel={close}>
      <p>{text}</p>
    </S.AlertBox>
  );
}

export default ConfirmAlertModal;
